import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/athena/Navbar";
import Hero from "@/components/athena/Hero";
import About from "@/components/athena/About";
import Domains from "@/components/athena/Domains";
import Products from "@/components/athena/Products";
import Science from "@/components/athena/Science";
import Why from "@/components/athena/Why";
import Team from "@/components/athena/Team";
import Contact from "@/components/athena/Contact";
import Footer from "@/components/athena/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import QualityPolicy from "@/pages/QualityPolicy";
import Careers from "@/pages/Careers";

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = "Athena Nutrascience — Nutraceuticals · Biotechnology · Life Sciences";
  }, []);
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    // Slight delay so sections have mounted
    const t = setTimeout(() => {
      if (target === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 60);
    return () => clearTimeout(t);
  }, [location.state]);
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Domains />
        <Products />
        <Science />
        <Why />
        <Team />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A1713",
            color: "#F8F7F4",
            border: "1px solid #1A382A",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/careers" element={<CareersPage />} />
      </Routes>
    </BrowserRouter>
  );
}

const PrivacyPage = () => (
  <>
    <PrivacyPolicy />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0A1713",
          color: "#F8F7F4",
          border: "1px solid #1A382A",
          borderRadius: "2px",
          fontFamily: "Manrope, sans-serif",
        },
      }}
    />
  </>
);

const TermsPage = () => (
  <>
    <Terms />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0A1713",
          color: "#F8F7F4",
          border: "1px solid #1A382A",
          borderRadius: "2px",
          fontFamily: "Manrope, sans-serif",
        },
      }}
    />
  </>
);

const QualityPage = () => (
  <>
    <QualityPolicy />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0A1713",
          color: "#F8F7F4",
          border: "1px solid #1A382A",
          borderRadius: "2px",
          fontFamily: "Manrope, sans-serif",
        },
      }}
    />
  </>
);

const CareersPage = () => (
  <>
    <Careers />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0A1713",
          color: "#F8F7F4",
          border: "1px solid #1A382A",
          borderRadius: "2px",
          fontFamily: "Manrope, sans-serif",
        },
      }}
    />
  </>
);

export default App;
